import { Injectable } from '@angular/core';
import { SessionCode } from './../enums/sessioncode.enum'
@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }


  set InventoryPlanningFilteredData(filteredData: any) {
    sessionStorage.setItem(SessionCode.InventoryPlanningFilterData, JSON.stringify(filteredData));
  }


  get InventoryPlanningFilteredData(): any {
    return JSON.parse(sessionStorage.getItem(SessionCode.InventoryPlanningFilterData) ?? JSON.stringify([]));
  }


  set InventoryPlanningMasterData(filteredData: any) {
    sessionStorage.setItem(SessionCode.InventoryPlanningMasterData, JSON.stringify(filteredData));
  }


  get InventoryPlanningMasterData(): any {
    return JSON.parse(sessionStorage.getItem(SessionCode.InventoryPlanningMasterData) ?? JSON.stringify([]));
  }

  set PartNosMasterData(partNosData: any) {
    sessionStorage.setItem(SessionCode.PartNosMasterData, JSON.stringify(partNosData));
  }


  get PartNosMasterData(): any {
    return JSON.parse(sessionStorage.getItem(SessionCode.PartNosMasterData) ?? JSON.stringify([]));
  }

  set PartCatColumnsList(PartCatColumnsList: any) {
    localStorage.setItem(SessionCode.PartCatColumnsList, JSON.stringify(PartCatColumnsList));
  }


  get PartCatColumnsList(): any {
    return JSON.parse(localStorage.getItem(SessionCode.PartCatColumnsList) ?? JSON.stringify([]));
  }

  set PartPlanningColumnsList(PartPlanningColumnsList: any) {
    sessionStorage.setItem(SessionCode.PartPlanningColumnsList, JSON.stringify(PartPlanningColumnsList));
  }


  get PartPlanningColumnsList(): any {
    return JSON.parse(sessionStorage.getItem(SessionCode.PartPlanningColumnsList) ?? JSON.stringify([]));
  }


  set userEmail(userEmail: any) {
    localStorage.setItem(SessionCode.userEmail, JSON.stringify(userEmail));
  }


  get userEmail(): any {
    return JSON.parse(localStorage.getItem(SessionCode.userEmail) ?? JSON.stringify([]));
  }

    set userName(userName: any) {
    localStorage.setItem(SessionCode.userName, JSON.stringify(userName));
  }


  get userName(): any {
    return JSON.parse(localStorage.getItem(SessionCode.userName) ?? JSON.stringify([]));
  }

  


}
